import React from 'react';
import { Row, Col } from 'reactstrap';
import { framework } from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import { ui } from 'saffroncodejs';
var PageManager = framework.PageManager;

class BimenamesalessayerResult extends React.Component {

    constructor(props) {

        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.codmeli = this.encodeSodurId(urlParams[0]);
        this.codeyekta = this.encodeSodurId(urlParams[1]);
        this.state = {
            isloading: true,
            activeTab: 1,
            data: {},

        }
        this.state.data = {};
        this.loadDetail();

    }

    encodeSodurId(encodedId) {
        return encodedId;
    }

    componentWillReceiveProps(props) {
    }

    loadDetail() {
        Axios.post(BimeManager.reactRedirectDomain,
            BimeManager.makeBody("/NovinInsuranceServices/Cmn/api/Policy/ValidationInqueryByUnqCod",
                { NtlCod: this.codmeli, PlcyUnqCod: this.codeyekta }
            ),
            BimeManager.header())
            .then((result) => {
                console.log("result.data : ", JSON.stringify(result.data));
                this.setState({ data: result.data, isloading: false });


            })
            .catch((error) => { alert(error) })


    }


    render() {
        return (

            <div>
                <Row>
                    <Col sm="12" className="alignRight title">
                        <h4>اطلاعات بیمه نامه ثالث سایر شرکتها</h4>
                    </Col>
                </Row>

                {!this.state.isloading ?
                    this.state.data.ErrorMessage===null ? <Row>
                        <Col sm="12">
                            <div className="container ListOfList">
                            <Row>
                                    <Col sm="12" className="alignRight"><span className="bold-head">نام شرکت:</span>{this.state.data.CmpNam}</Col>
                                    <Col sm="12" className="alignRight"><span className="bold-head">تاریخ پایان بیمه نامه:</span>{this.state.data.EndDte}</Col>
                                    <Col sm="12" className="alignRight"><span className="bold-head">شماره بیمه نامه:</span>{this.state.data.PlcyDoc}</Col>
                                    <Col sm="12" className="alignRight"><span className="bold-head">تاریخ شروع بیمه نامه:</span>{this.state.data.sttDte}</Col>
                                    <Col sm="12" className="alignRight"><span className="bold-head">کد یکتا بیمه نامه در بیمه مرکزی:</span>{this.state.data.UnqCod}</Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col sm="12">
                            <div className="container ListOfList">
                            <Row>
                                    <Col sm="12" className="alignCenter"><span className="bold-head">بیمه نامه ای با مشخصات وارد شده یافت نشد</span></Col>
                                </Row>
                                
                            </div>
                        </Col>
                        
                    </Row>


                    : (<ui.Preloader />)



                }
                <br/>
            </div>

        )

    }
}

export default BimenamesalessayerResult;


// WEBPACK FOOTER //
// ./src/components/EtelaatBimeSayerSherkatha/BimenamesalessayerResult.js